import { _ep0, _mw0, command } from "../commandBuilder";
import { UpdateChurch$ } from "../schemas/schemas_0";
export class UpdateChurchCommand extends command(_ep0, _mw0, "UpdateChurch", UpdateChurch$) {
}
